import _classCallCheck from "/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _possibleConstructorReturn from "/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _wrapNativeSuper from "/home/jfontirroig/pact/dappcrosscheck/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/wrapNativeSuper";
export var SerializationError =
/*#__PURE__*/
function (_Error) {
  _inherits(SerializationError, _Error);

  function SerializationError(message) {
    var _this;

    _classCallCheck(this, SerializationError);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SerializationError).call(this, message));
    _this.message = message;
    _this.name = _this.constructor.name;

    if (Error.captureStackTrace) {
      Error.captureStackTrace(_assertThisInitialized(_assertThisInitialized(_this)), _this.constructor);
    }

    return _this;
  }

  return SerializationError;
}(_wrapNativeSuper(Error));
export var DeserializationError =
/*#__PURE__*/
function (_Error2) {
  _inherits(DeserializationError, _Error2);

  function DeserializationError(message) {
    var _this2;

    _classCallCheck(this, DeserializationError);

    _this2 = _possibleConstructorReturn(this, _getPrototypeOf(DeserializationError).call(this, message));
    _this2.message = message;
    _this2.name = _this2.constructor.name;

    if (Error.captureStackTrace) {
      Error.captureStackTrace(_assertThisInitialized(_assertThisInitialized(_this2)), _this2.constructor);
    }

    return _this2;
  }

  return DeserializationError;
}(_wrapNativeSuper(Error));
export var NotImplementedError =
/*#__PURE__*/
function (_Error3) {
  _inherits(NotImplementedError, _Error3);

  function NotImplementedError(message) {
    var _this3;

    _classCallCheck(this, NotImplementedError);

    _this3 = _possibleConstructorReturn(this, _getPrototypeOf(NotImplementedError).call(this, message));
    _this3.message = message;
    _this3.name = _this3.constructor.name;

    if (Error.captureStackTrace) {
      Error.captureStackTrace(_assertThisInitialized(_assertThisInitialized(_this3)), _this3.constructor);
    }

    return _this3;
  }

  return NotImplementedError;
}(_wrapNativeSuper(Error));
export var SigningError =
/*#__PURE__*/
function (_Error4) {
  _inherits(SigningError, _Error4);

  function SigningError(message) {
    var _this4;

    _classCallCheck(this, SigningError);

    _this4 = _possibleConstructorReturn(this, _getPrototypeOf(SigningError).call(this, message));
    _this4.message = message;
    _this4.name = _this4.constructor.name;

    if (Error.captureStackTrace) {
      Error.captureStackTrace(_assertThisInitialized(_assertThisInitialized(_this4)), _this4.constructor);
    }

    return _this4;
  }

  return SigningError;
}(_wrapNativeSuper(Error));
export var VerificationError =
/*#__PURE__*/
function (_Error5) {
  _inherits(VerificationError, _Error5);

  function VerificationError(message) {
    var _this5;

    _classCallCheck(this, VerificationError);

    _this5 = _possibleConstructorReturn(this, _getPrototypeOf(VerificationError).call(this, message));
    _this5.message = message;
    _this5.name = _this5.constructor.name;

    if (Error.captureStackTrace) {
      Error.captureStackTrace(_assertThisInitialized(_assertThisInitialized(_this5)), _this5.constructor);
    }

    return _this5;
  }

  return VerificationError;
}(_wrapNativeSuper(Error));